export const initMatomo = (matomoUrl, siteId) => {
  try {
    window._paq = window._paq || [];
    window._paq.push(['requireCookieConsent']);
    window._paq.push(['trackPageView']);
    window._paq.push(['enableLinkTracking']);

    const u = matomoUrl.endsWith('/') ? matomoUrl : `${matomoUrl}/`;
    window._paq.push(['setTrackerUrl', `${u}matomo.php`]);
    window._paq.push(['setSiteId', siteId]);

    // Don't inject remote Matomo script in local dev to avoid adblock / dev-server issues.
    // This prevents ERR_BLOCKED_BY_CLIENT from breaking the dev experience (blank page).
    const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
    const isLocalhost =
      hostname === 'localhost' ||
      hostname === '127.0.0.1' ||
      hostname.endsWith('.local') ||
      hostname === '';

    // If the configured matomoUrl itself points to localhost, treat it as local too.
    const matomoHostIsLocal = /localhost|127\.0\.0\.1/.test(u);

    if (isLocalhost || matomoHostIsLocal) {
      // In dev, we keep the _paq queue operational but avoid injecting the external script.
      // This keeps your app working locally without being blocked by adblockers.
      return;
    }

    const d = document;
    const g = d.createElement('script');
    const s = d.getElementsByTagName('script')[0];
    g.type = 'text/javascript';
    g.async = true;
    g.src = `${u}matomo.js`;
    s.parentNode.insertBefore(g, s);
  } catch (err) {
    // Do not let analytics break the app. Log warning for debugging.
    console.warn('Matomo init skipped or failed:', err && err.message ? err.message : err);
  }
};

export const acceptMatomoCookies = () => {
  window._paq = window._paq || [];
  window._paq.push(['rememberCookieConsentGiven']);
};

export const trackEvent = (category, action, name = '', value = 0) => {
  window._paq = window._paq || [];
  window._paq.push(['trackEvent', category, action, name, value]);
};

export const trackPageView = (title) => {
  window._paq = window._paq || [];
  window._paq.push(['setCustomUrl', `${window.location.pathname}${window.location.search}${window.location.hash}`]);
  window._paq.push(['setDocumentTitle', title]);
  window._paq.push(['trackPageView']);
};
